import { Suspense, lazy, useCallback } from 'react';

const Spline = lazy(() => import('@splinetool/react-spline'));

function SplineScene({ onLoad }) {
  return (
    <Spline
      scene="/scene-clean.splinecode"
      onLoad={onLoad}
      style={{ width: '100%', height: '100%' }}
    />
  );
}

export default function EtherealRingsSpline({ brightness = 0.6, scale = 1.0 }) {
  const handleLoad = useCallback((splineApp) => {
    try {
      // Slow all object animations to ~35% speed
      if (splineApp?.getAllObjects) {
        splineApp.getAllObjects().forEach((obj) => {
          if (obj?.animations?.length) {
            obj.animations.forEach((a) => { if (a) a.timeScale = 0.35; });
          }
        });
      }
    } catch (e) {
      // silently ignore — speed control is best-effort
    }
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          transform: `scale(${scale})`,
          transformOrigin: 'center center',
          filter: `saturate(0.9) brightness(${brightness})`,
        }}
      >
        <Suspense fallback={null}>
          <SplineScene onLoad={handleLoad} />
        </Suspense>
      </div>

      {/* Hide "Built with Spline" badge injected by the runtime */}
      <style>{`
        a[href*="spline.design"],
        a[href*="spline.design"] *,
        div[class*="watermark"],
        div[class*="logo"][style*="spline"],
        canvas ~ div,
        canvas + div {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      `}</style>
    </div>
  );
}
